import React, { useState, useContext, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import NProgress from 'nprogress';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const CreateToken = () => {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [generatingToken, setGeneratingToken] = useState(false);
    const [tokens, setTokens] = useState([]);
    const [tokenDescription, setTokenDescription] = useState('');
    const [newToken, setNewToken] = useState(null);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

    // Fetch existing tokens

    useEffect(() => {
        const fetchTokens = async () => {
            try {
                setLoading(true);
                NProgress.start();
                const res = await axios.get(`${API_URL}/token`);
                setTokens(res.data);
            } catch (err) {
                console.error("Failed to fetch tokens:", err);

                if (err.response?.status === 403) {
                    toast.warn("Bu sahypa girip bilmersiňiz");
                    navigate("/"); // Baş sahypa ugrukdyr
                } else {
                    toast.error("API tokenlaryny ýükläp bolmady");
                }

            } finally {
                setLoading(false);
                NProgress.done();
            }
        };

        fetchTokens();
    }, [API_URL, navigate]);


    // Generate new token
    const handleCreateToken = async (e) => {
        e.preventDefault();
        if (!tokenDescription.trim()) {
            toast.error("Token üçin düşündiriş giriziň");
            return;
        }

        try {
            setGeneratingToken(true);
            NProgress.start();

            const res = await axios.post(`${API_URL}/token/create`, { description: tokenDescription.trim() });
            const tokenObj = res.data.token;               // { id, token, description, isActive, ... }
            setNewToken(tokenObj.token);                    // diňe jez token hex set etýäris
            setTokens([tokenObj, ...tokens]);               // sanawa täze obýekti goşýarys
            setTokenDescription('');
            toast.success("API token üstünlikli döredildi");
        } catch (err) {
            console.error("Failed to create token:", err);
            toast.error(err.response?.data?.message || err.message || "API token döredip bolmady");
        } finally {
            setGeneratingToken(false);
            NProgress.done();
        }
    };

    // Revoke (deactivate) token
    const handleRevokeToken = async (tokenId) => {
        if (!window.confirm("API tokenyny deaktiw etmäge ynanýarsyňyzmy?")) return;

        try {
            NProgress.start();
            await axios.put(`${API_URL}/token/deactivate/${tokenId}`);
            // lokal sanawy täzeläýäs
            setTokens(tokens.map(t =>
                t.id === tokenId ? { ...t, isActive: false } : t
            ));
            toast.success("API token üstünlikli deaktiw edildi");
        } catch (err) {
            console.error("Failed to deactivate token:", err);
            toast.error(err.response?.data?.message || "API tokeny deaktiw etmek başartmady");
        } finally {
            NProgress.done();
        }
    };

    return (
        <>
            <Helmet>
                <title>API SMS - SMS Serwis</title>
            </Helmet>

            <div className="grid grid-cols-1 gap-6">
                {/* New Token Form */}
                <div className="bg-white rounded-lg shadow p-6">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">Täze API Token Döret</h2>
                    <form onSubmit={handleCreateToken}>
                        <div className="relative z-0 w-full mb-4 group">

                            <input
                                type="text"
                                id="tokenDescription"
                                value={tokenDescription}
                                onChange={e => setTokenDescription(e.target.value)}
                                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                placeholder=""
                                disabled={generatingToken}
                            />
                            <label id="tokenDescription" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Token bellik:</label>

                        </div>
                        <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                            disabled={generatingToken}
                        >
                            {generatingToken ? 'Döredilýär...' : 'Token Döret'}
                        </button>
                        <NavLink to="/dev-docs" className={"m-2 inline-flex justify-center py-2 px-2 bg-indigo-800 text-white rounded-md hover:bg-indigo-700"}> Developer Documentation </NavLink>

                    </form>

                    {newToken && (
                        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-md">
                            <p className="font-medium text-yellow-800">Täze tokenyňyz. DIŇE BIR GEZEK görkezilýär!</p>
                            <code className="block mt-2 p-2 bg-gray-800 text-green-400 rounded overflow-x-auto">
                                {newToken}
                            </code>
                            <p className="mt-2 text-sm text-gray-600">
                                Bu tokeny howpsuz ýerde saklaň. Sahypany ýapanyňyzdan soň, gaýtadan görüp bolmaýar.
                            </p>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(newToken);
                                    toast.success("Token göçürildi");
                                }}
                                className="mt-3 inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-700 text-xs rounded-md hover:bg-indigo-200"
                            >
                                Göçür
                            </button>
                        </div>
                    )}
                </div>

                {/* Tokens List */}
                <div className="bg-white rounded-lg shadow p-6">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">API Tokenlar</h2>

                    {loading ? (
                        <p className="text-center py-6">Tokenlar ýüklenýär...</p>
                    ) : tokens.length === 0 ? (
                        <p className="text-center py-6 text-gray-500">Hiç hili API token döredilmedik!</p>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        {['#', 'Düşündiriş', 'Token', 'Döredilen senesi', 'Status', 'Hereketler']
                                            .map((h, i) => (
                                                <th key={i} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                                                    {h}
                                                </th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {tokens.map((t, idx) => (
                                        <tr key={t.id}>
                                            <td className="px-6 py-4 text-sm text-gray-500">{idx + 1}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{t.description}</td>
                                            <td className="px-6 py-4 text-sm text-gray-700 font-mono truncate max-w-xs">
                                                {t.token}
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-500">
                                                {new Date(t.createdAt).toLocaleString()}
                                            </td>
                                            <td className={`px-6 py-4 text-sm ${t.isActive ? 'text-green-600' : 'text-red-600'}`}>
                                                {t.isActive ? 'Işjeň' : 'Işjeň däl'}
                                            </td>
                                            <td className="px-6 py-4 text-sm">
                                                {t.isActive && (
                                                    <button
                                                        onClick={() => handleRevokeToken(t.id)}
                                                        className="text-red-600 hover:text-red-800"
                                                    >
                                                        Deaktiw et
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default CreateToken;